import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgThumbsUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 23"
    stroke="#979797"
    {...props}
  >
    <path
      fill="none"
      d="M9.733 1.012c-.823-.08-.945.235-1.2 1.147-.256.912-1.397 3.566-2.204 4.917-.806 1.35-2.302 3.188-3.285 4.469-.983 1.28-1.345 1.021-2.044 1.041v7.503h1.394c.148-.045.791.154 1.93.599 1.71.666 4.229 1.282 6.21 1.282 1.981 0 5.724.224 7.501-.547 1.778-.77 1.53-1.29 1.53-1.598 0-.207-.184-.57-.551-1.093 1.099-.52 1.648-1.091 1.648-1.711 0-.62-.366-1.185-1.097-1.693.846-.47 1.268-1.077 1.268-1.823s-.534-1.303-1.601-1.672c.25-.428.372-.882.365-1.362-.01-.72-.644-1.411-2.08-1.427-1.437-.015-3.544.48-4.444.641-.9.162-2.667.14-2.748-1.544-.082-1.685 1.054-2.735 1.17-4.702.117-1.967-.94-2.348-1.762-2.427z"
    />
  </svg>
);
const Memo = memo(SvgThumbsUp);
export default Memo;
